import { Stack } from 'components/Stack';
import styled from 'styled-components';
import { mediaBreakpointDown } from 'styles/grid';

export const Container = styled(Stack)`
  height: 100%;
  ${mediaBreakpointDown.sm} {
    text-align: center;
  }
`;

export const Header = styled.div`
  font-weight: 600;
  font-size: 20px;
`;

export const Body = styled.div`
  font-weight: 400;
  font-size: 16px;
  margin-top: 8px;
`;
